/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../common/currency';
import './gateway';
import '../../common/emv';
import '../common/common';
import '../../payments/refund';
import '../../payments/auth';
import '../../payments/common';
import '../../payments/refund_reversal';
import '../../payments/push_money';
import './mastercard_mip';
import './batch';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "esperanto": {
        "nested": {
          "model": {
            "nested": {
              "RefundOptions": {
                "fields": {
                  "isUnlinked": {
                    "type": "bool",
                    "id": 2,
                    "rule": "optional",
                    "options": {
                      "default": false
                    }
                  }
                }
              },
              "RefundReservationIntent": {
                "fields": {
                  "createdAtMs": {
                    "type": "uint64",
                    "id": 1,
                    "rule": "optional"
                  },
                  "amount": {
                    "type": ".squareup.common.Money",
                    "id": 2,
                    "rule": "optional"
                  },
                  "gatewayData": {
                    "type": ".squareup.esperanto.model.GatewayData",
                    "id": 3,
                    "rule": "optional"
                  },
                  "emvTags": {
                    "type": ".squareup.common.EmvTags",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "RefundReservationResult": {
                "fields": {
                  "status": {
                    "type": ".squareup.esperanto.common.OperationStatus",
                    "id": 1,
                    "rule": "optional"
                  },
                  "declineReason": {
                    "type": ".squareup.payments.refund.RefundError",
                    "id": 2,
                    "rule": "optional"
                  },
                  "authorizationCode": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "failureReasons": {
                    "type": ".squareup.payments.auth.AuthorizationError",
                    "id": 4,
                    "rule": "repeated"
                  },
                  "wasOnlineRefundAuthAttempted": {
                    "type": "bool",
                    "id": 5,
                    "rule": "optional"
                  },
                  "wasOnlineRefundAuthDeclineSuppressed": {
                    "type": "bool",
                    "id": 6,
                    "rule": "optional"
                  },
                  "settlementShard": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "cardNetwork": {
                    "type": ".squareup.payments.common.CardNetwork",
                    "id": 8,
                    "rule": "optional"
                  },
                  "selectedAcquirer": {
                    "type": ".squareup.payments.common.AcquiringEntity",
                    "id": 9,
                    "rule": "optional"
                  },
                  "remainingBalanceAmount": {
                    "type": ".squareup.common.Money",
                    "id": 10,
                    "rule": "optional"
                  }
                }
              },
              "RefundReversalIntent": {
                "fields": {
                  "createdAtMs": {
                    "type": "uint64",
                    "id": 1,
                    "rule": "optional"
                  },
                  "reason": {
                    "type": ".squareup.payments.refund_reversal.RefundReversalReason",
                    "id": 2,
                    "rule": "optional"
                  },
                  "description": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "refundReversalGatewayTransactionId": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "RefundReversalResult": {
                "fields": {}
              },
              "RefundCompletionIntent": {
                "fields": {
                  "createdAtMs": {
                    "type": "uint64",
                    "id": 1,
                    "rule": "optional"
                  },
                  "amount": {
                    "type": ".squareup.common.Money",
                    "id": 2,
                    "rule": "optional"
                  },
                  "processingDateMs": {
                    "type": "uint64",
                    "id": 3,
                    "rule": "optional"
                  },
                  "businessDateMs": {
                    "type": "uint64",
                    "id": 4,
                    "rule": "optional"
                  },
                  "refundGatewayTransactionId": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "senderInfo": {
                    "type": ".squareup.payments.pushmoney.SenderInfo",
                    "id": 6,
                    "rule": "optional"
                  },
                  "refundCompletionGatewayTransactionId": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  }
                }
              },
              "RefundCompletionResult": {
                "fields": {
                  "status": {
                    "type": ".squareup.esperanto.common.OperationStatus",
                    "id": 1,
                    "rule": "optional"
                  },
                  "declineReason": {
                    "type": ".squareup.payments.refund.RefundError",
                    "id": 2,
                    "rule": "optional"
                  },
                  "acknowledgedByPbsAtMs": {
                    "type": "int64",
                    "id": 3,
                    "rule": "optional"
                  },
                  "messageFromPbs": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "RefundReservationType": {
                "values": {
                  "NOOP": 1,
                  "ONLINE": 2,
                  "ONLINE_AUTHORIZATION_SUPPORTED": 3
                }
              },
              "RefundGatewayProperties": {
                "fields": {
                  "mastercardMip": {
                    "type": ".squareup.esperanto.model.MipRefundGatewayProperties",
                    "id": 1
                  }
                },
                "nested": {
                  "properties": {
                    "oneof": ["mastercardMip"]
                  }
                }
              },
              "Refund": {
                "fields": {
                  "options": {
                    "type": ".squareup.esperanto.model.RefundOptions",
                    "id": 1,
                    "rule": "optional"
                  },
                  "refundIntent": {
                    "type": ".squareup.esperanto.model.RefundCompletionIntent",
                    "id": 2,
                    "rule": "optional"
                  },
                  "refundResult": {
                    "type": ".squareup.esperanto.model.RefundCompletionResult",
                    "id": 3,
                    "rule": "optional"
                  },
                  "refundUuid": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "refundRequestIdempotenceKey": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "isOmnibusMastered": {
                    "type": "bool",
                    "id": 6,
                    "rule": "optional",
                    "options": {
                      "default": false
                    }
                  },
                  "batchDetails": {
                    "type": ".squareup.esperanto.model.BatchDetails",
                    "id": 7,
                    "rule": "optional"
                  },
                  "refundReservationIntent": {
                    "type": ".squareup.esperanto.model.RefundReservationIntent",
                    "id": 8,
                    "rule": "optional"
                  },
                  "refundReservationResult": {
                    "type": ".squareup.esperanto.model.RefundReservationResult",
                    "id": 9,
                    "rule": "optional"
                  },
                  "refundReversalIntent": {
                    "type": ".squareup.esperanto.model.RefundReversalIntent",
                    "id": 10,
                    "rule": "optional"
                  },
                  "refundReversalResult": {
                    "type": ".squareup.esperanto.model.RefundReversalResult",
                    "id": 11,
                    "rule": "optional"
                  },
                  "refundBillId": {
                    "type": "string",
                    "id": 12,
                    "rule": "optional"
                  },
                  "refundOrderId": {
                    "type": "string",
                    "id": 13,
                    "rule": "optional"
                  },
                  "checkoutRefundId": {
                    "type": "string",
                    "id": 14,
                    "rule": "optional"
                  },
                  "sourceAppId": {
                    "type": "string",
                    "id": 15,
                    "rule": "optional"
                  },
                  "gatewayData": {
                    "type": ".squareup.esperanto.model.GatewayData",
                    "id": 16,
                    "rule": "optional"
                  },
                  "declinedRefundAuthGatewayData": {
                    "type": ".squareup.esperanto.model.GatewayData",
                    "id": 17,
                    "rule": "optional"
                  },
                  "gatewayProperties": {
                    "type": ".squareup.esperanto.model.RefundGatewayProperties",
                    "id": 18,
                    "rule": "optional"
                  },
                  "appFeeUnitToken": {
                    "type": "string",
                    "id": 19,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.RefundOptions && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.RefundReservationIntent && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.RefundReservationResult && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.RefundReversalIntent && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.RefundReversalResult && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.RefundCompletionIntent && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.RefundCompletionResult && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.RefundReservationType && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.RefundGatewayProperties && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.Refund) {
  $root.addJSON(jsonData);
}

/**
 * Set of refund options.
 *
 * NOTE(botros): do not use tag 1. Previously used for is_partial.
 *
 * SOURCE RefundOptions @ squareup/esperanto/model/refund.proto at 26:1
 */
export const RefundOptions = $root.lookupType('squareup.esperanto.model.RefundOptions');
fixType(RefundOptions);
Builder.createAndAttachToType(RefundOptions);
/**
 * Represents a refund reservation, which determines whether the refund
 * can be performed or not.
 *
 * SOURCE RefundReservationIntent @ squareup/esperanto/model/refund.proto at 35:1
 */
export const RefundReservationIntent = $root.lookupType('squareup.esperanto.model.RefundReservationIntent');
fixType(RefundReservationIntent, {
  createdAtMs: {
    required: true
  },
  amount: {
    required: true
  }
});
Builder.createAndAttachToType(RefundReservationIntent);
/**
 * SOURCE RefundReservationResult @ squareup/esperanto/model/refund.proto at 60:1
 */
export const RefundReservationResult = $root.lookupType('squareup.esperanto.model.RefundReservationResult');
fixType(RefundReservationResult);
Builder.createAndAttachToType(RefundReservationResult);
/**
 * Represents a refund reversal, which reverses a prior refund reservation.
 *
 * SOURCE RefundReversalIntent @ squareup/esperanto/model/refund.proto at 117:1
 */
export const RefundReversalIntent = $root.lookupType('squareup.esperanto.model.RefundReversalIntent');
fixType(RefundReversalIntent, {
  createdAtMs: {
    required: true
  }
});
Builder.createAndAttachToType(RefundReversalIntent);
/**
 * A refund reversal's result. Empty, since reversals always succeed.
 *
 * SOURCE RefundReversalResult @ squareup/esperanto/model/refund.proto at 141:1
 */
export const RefundReversalResult = $root.lookupType('squareup.esperanto.model.RefundReversalResult');
fixType(RefundReversalResult);
Builder.createAndAttachToType(RefundReversalResult);
/**
 * Refund completion intent.
 *
 * SOURCE RefundCompletionIntent @ squareup/esperanto/model/refund.proto at 146:1
 */
export const RefundCompletionIntent = $root.lookupType('squareup.esperanto.model.RefundCompletionIntent');
fixType(RefundCompletionIntent);
Builder.createAndAttachToType(RefundCompletionIntent);
/**
 * Refund completion result.
 *
 * SOURCE RefundCompletionResult @ squareup/esperanto/model/refund.proto at 189:1
 */
export const RefundCompletionResult = $root.lookupType('squareup.esperanto.model.RefundCompletionResult');
fixType(RefundCompletionResult);
Builder.createAndAttachToType(RefundCompletionResult);
/**
 * The refund reservation handling strategy.
 *
 * SOURCE RefundReservationType @ squareup/esperanto/model/refund.proto at 206:1
 */
export const RefundReservationType = $root.lookupEnum('squareup.esperanto.model.RefundReservationType').values;
/**
 * Attributes of a Refund that are gateway specific and are visible beyond payment processing
 * systems.
 *
 * SOURCE RefundGatewayProperties @ squareup/esperanto/model/refund.proto at 230:1
 */
export const RefundGatewayProperties = $root.lookupType('squareup.esperanto.model.RefundGatewayProperties');
fixType(RefundGatewayProperties);
Builder.createAndAttachToType(RefundGatewayProperties);
/**
 * Refund transaction.
 *
 * SOURCE Refund @ squareup/esperanto/model/refund.proto at 239:1
 */
export const Refund = $root.lookupType('squareup.esperanto.model.Refund');
fixType(Refund);
Builder.createAndAttachToType(Refund);